// extracted by mini-css-extract-plugin
module.exports = {"title":"OtherDestinationSection_title__1nMSF"};